import { Workbox } from 'workbox-window';

const SW_URL = '/sw.js';
const SW_UPDATE_EVENT = 'pwa:update-ready';
const SW_OFFLINE_READY_EVENT = 'pwa:offline-ready';

let wbInstance: Workbox | null = null;

export function getWorkbox(): Workbox | null {
    return wbInstance;
}

/**
 * Prompt the waiting SW to activate, then reload once it takes control.
 * Called by the update-prompt component when the user clicks "Reload".
 */
export function applyPwaUpdate(): void {
    const wb = wbInstance;
    if (!wb) {
        window.location.reload();
        return;
    }
    wb.addEventListener('controlling', () => window.location.reload());
    wb.messageSkipWaiting();
}

export function registerPwaServiceWorker(): void {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // The Vite dev server doesn't emit a real SW file unless devOptions.enabled
    // is set; registering would 404 and clutter the console.
    if (import.meta.env.DEV) return;

    const wb = new Workbox(SW_URL, { scope: '/' });
    wbInstance = wb;

    wb.addEventListener('waiting', () => {
        window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT));
    });

    wb.addEventListener('activated', (event) => {
        // First activation = offline shell is now ready.
        if (!event.isUpdate) {
            window.dispatchEvent(new CustomEvent(SW_OFFLINE_READY_EVENT));
        }
    });

    wb.register().catch((err) => {
        console.warn('[pwa] SW registration failed', err);
    });
}

export const PWA_EVENTS = {
    UPDATE_READY: SW_UPDATE_EVENT,
    OFFLINE_READY: SW_OFFLINE_READY_EVENT,
} as const;
